import * as Sentry from '@sentry/nextjs'

type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug'

type CaptureExceptionOptions = {
    level?: SeverityLevel // Optionally control the severity level of the exception
}

export function captureSentryException(error: Error | string, options: CaptureExceptionOptions = {}): string {
    const { level = 'error' } = options

    // Capture exception with severity level
    return Sentry.captureException(error, {
        level, // Severity level
    })
}
